import { render, staticRenderFns } from "./CTTAreaPromoterCRM.vue?vue&type=template&id=68099541"
import script from "./CTTAreaPromoterCRM.vue?vue&type=script&lang=js"
export * from "./CTTAreaPromoterCRM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports